import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralContainer = styled.div`
  position: fixed;
  right: 7%;
  top: 4rem;
  max-height: 500px;
  overflow-y: auto;
  width: 100%;
  max-width: 300px;
  z-index: 70;
  background: ${({ theme }) => theme.primaryBackgroundLight};
  box-shadow: 0px 4px 44px 0px rgba(43, 56, 87, 0.10);
  border-radius: 5px;
  &::-webkit-scrollbar {
    width: 0.3em;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.neutral.gray[1000]};
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
  .modal-notification_title {
    position: relative;
    display: flex;
    align-items: center;
    padding: 16px 16px 0;
    justify-content: space-between;
    color: ${({ theme }) => theme.secondaryDarkOne};
    font-size: 18px;
    font-weight: 900;
    margin-bottom: 40px;
    button {
      position: absolute;
      right: 4%;
      padding: 0;
    }
    path {
      fill: ${({ theme }) => theme.primary.purpleMedium};
    }
  }
  .arrow-up {
    width: 0;
    height: 0;
    border-left: 1.2rem solid transparent;
    border-right: 1.3rem solid transparent;
    border-bottom: 2rem solid ${({ theme }) => theme.neutral.white};
  }
`;

export const CloseIconSvg = styled.div`
  svg {
    width: 15px;
    height: 15px;
  }
`;
